import React from 'react';
import { CakeIcon, CakeSliceIcon, ChefHatIcon, CookieIcon, StoreIcon, WheatIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  chef: ChefHatIcon,
  wheat: WheatIcon,
  cream: CakeSliceIcon,
  cake: CakeIcon,
  cookie: CookieIcon,
  store: StoreIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-pink-600', 'bg-orange-600', 'bg-purple-600', 'bg-rose-600', 'bg-green-700', 'bg-blue-600'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-rose" data-id="element-163" data-mp="atmf2zk1rl0q">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-164" data-mp="5wcf4pz17qyn">
        <p className="font-script text-[0.9rem] font-bold italic leading-tight text-brand-pinkdark" data-id="element-165" data-mp="ks23uvvlqi72">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1 font-display text-base font-extrabold leading-tight text-brand-choco sm:text-xl" data-id="element-166" data-mp="frnxdi9nfgb5">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1 font-display text-[0.75rem] font-black uppercase leading-tight text-brand-pink sm:text-sm" data-id="element-167" data-mp="3fb0x77zk3hi0">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-brand-choco/80" data-id="element-168" data-mp="3k80vgwq5zfyk">
          No es simplemente otro ebook de recetas. Es una ruta de aprendizaje que
          organiza los conocimientos fundamentales para que comprendas qué
          preparar primero, cómo mejorar tus técnicas y cómo convertir tus
          productos de pastelería en una oportunidad de emprendimiento.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-169" data-mp="bulfh69a88wg">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg border border-brand-blush bg-white text-left text-brand-choco" data-id="element-170" data-mp="gu6knyf1pdhm" data-mpi={i}>
                <span className={`flex w-12 flex-shrink-0 flex-col items-center justify-center gap-1 text-white ${TOMO_COLORS[i]}`} data-id="element-171" data-mp="2mn4g9tzyx6lv">
                  <span className="font-display text-[0.5rem] font-bold uppercase tracking-wider" data-id="element-172" data-mp="2hu343tr5bl5z">
                    Tomo
                  </span>
                  <span className="font-display text-2xl font-black leading-none" data-id="element-173" data-mp="2rknzl8biw9ko">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-174" data-mp="35je4390o9bj2" />
                </span>
                <div className="p-2.5" data-id="element-175" data-mp="30mx7dqfepoud">
                  <h3 className="sr-only" data-id="element-176" data-mp="1b7fx7dpu4rqc">Tomo {i + 1}</h3>
                  <p className="font-display text-[0.78rem] font-extrabold uppercase leading-tight" data-id="element-177" data-mp="1b7zd6ovxd61q">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-brand-choco/80" data-id="element-178" data-mp="3hv6hb7i2cqzq">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-179" data-mp="384vexpe12puy">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}